"use client";
import { jsxs as l, jsx as e } from "react/jsx-runtime";
const d = ({
  title: r,
  titleId: n,
  desc: o,
  descId: i,
  ...t
}) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    "aria-hidden": "true",
    "data-slot": "icon",
    width: 24,
    height: 24,
    "aria-labelledby": n,
    "aria-describedby": i,
    ...t,
    children: [
      o ? /* @__PURE__ */ e("desc", { id: i, children: o }) : null,
      r ? /* @__PURE__ */ e("title", { id: n, children: r }) : null,
      /* @__PURE__ */ e(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: 1.5,
          d: "M12 3v2M5.3141 7.3141 3.9 5.9m14.7859 1.4142L20.1 5.9M6 15c0-3.3137 2.6863-6 6-6s6 2.6863 6 6m4 0H2m17 4H5"
        }
      )
    ]
  }
);
export {
  d as default
};
//# sourceMappingURL=AfternoonIcon.js.map
